<!--
  ELSA's avatar (AB#21202).

  Drawn, not photographed, and that is a deliberate constraint rather than a
  budget one. A photoreal face on an agent tells people they are talking to a
  person, and everything else in this feature argues the opposite — that the
  reading is generated, checkable against cited evidence, and sometimes wrong.
  A real likeness is also not undoable once it is sitting over customers' order
  data.

  Drawn for 30px first. There are no eyes: at this size they are two grey
  pixels that read as noise, or worse, as a stare. Silhouette and hair carry
  "a person" on their own, and the shape survives being scaled down further for
  a narrow pane.

  The palette is the agent purple, kept away from the brand teal on purpose:
  teal already means "this control is selected", and a second meaning on one
  hue makes neither legible.
-->
<template>
  <svg class="elsa-avatar" viewBox="0 0 40 40" aria-hidden="true" focusable="false">
    <circle cx="20" cy="20" r="20" :fill="ground" />
    <!-- shoulders -->
    <path d="M7 36.5C9 30.5 14 27.5 20 27.5s11 3 13 9z" fill="#7c5cd6" />
    <!-- hair, falling behind the face -->
    <path
      d="M10.5 21c0-7.5 4-12 9.5-12s9.5 4.5 9.5 12c0 3.5-.7 5.8-2 7V18H12.5v10c-1.3-1.2-2-3.5-2-7z"
      fill="#5b3fb0"
    />
    <circle cx="20" cy="19.6" r="6.4" fill="#f7ece3" />
    <!-- fringe -->
    <path
      d="M13.6 17.4C14.8 13.6 17.2 11.6 20 11.6s5.2 2 6.4 5.8c-2.2-1.4-4.2-2-6.4-2s-4.2.6-6.4 2z"
      fill="#5b3fb0"
    />
  </svg>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ ground?: string }>(), { ground: '#ffffff' });
</script>

<style scoped>
.elsa-avatar {
  display: block;
  flex: none;
  border-radius: 50%;
  width: 100%;
  height: 100%;
}
</style>
